import { render, staticRenderFns } from "./RolesPermissionsConfig.vue?vue&type=template&id=f9fc067c&scoped=true"
import script from "./RolesPermissionsConfig.vue?vue&type=script&lang=js"
export * from "./RolesPermissionsConfig.vue?vue&type=script&lang=js"
import style0 from "./RolesPermissionsConfig.vue?vue&type=style&index=0&id=f9fc067c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9fc067c",
  null
  
)

export default component.exports